import { functionLabel } from "../lib/constants";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgSrc = (url) => (url ? (url.startsWith("http") ? url : BACKEND + url) : "");

const THEME_FULL = {
  rose: ["#E75480", "#FCE4EC", "#4A1128"], bleu: ["#1E88E5", "#E3F2FD", "#0D3B66"],
  vert: ["#43A047", "#E8F5E9", "#1B4332"], orange: ["#FB8C00", "#FFF3E0", "#6A3805"],
  violet: ["#8E24AA", "#F3E5F5", "#3B1145"], beige: ["#C8A96A", "#F7F1E3", "#4A3B1E"],
  turquoise: ["#00ACC1", "#E0F7FA", "#064049"], corail: ["#FF7043", "#FBE9E7", "#5A1E0F"],
  lavande: ["#9575CD", "#EDE7F6", "#311B5B"], menthe: ["#26A69A", "#E0F2F1", "#0B3D3A"],
  jaune: ["#FDD835", "#FFFDE7", "#5A4B00"], rouge: ["#E53935", "#FFEBEE", "#5A0E0C"],
  indigo: ["#3949AB", "#E8EAF6", "#1A237E"], cyan: ["#00838F", "#E0F7FA", "#05343A"],
  lime: ["#7CB342", "#F1F8E9", "#33501A"], brun: ["#8D6E63", "#EFEBE9", "#3E2723"],
  gris: ["#607D8B", "#ECEFF1", "#263238"], bordeaux: ["#880E4F", "#FCE4EC", "#3B0620"],
  sauge: ["#7A9E7E", "#EEF3EC", "#2E3D2F"], ciel: ["#4FC3F7", "#E1F5FE", "#01465E"],
};
const LABELS = {
  fr: { title: "Planning des animations", morning: "Matin", afternoon: "Après-midi", with: "Avec", at: "À", in: "Au",
    days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
    months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    footer_res: "Planning des animations de la Résidence", from: "Du", to: "au" },
  nl: { title: "Activiteitenplanning", morning: "Ochtend", afternoon: "Namiddag", with: "Met", at: "Om", in: "In",
    days: ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"],
    months: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
    footer_res: "Activiteitenplanning van de Residentie", from: "Van", to: "tot" },
  en: { title: "Activity planning", morning: "Morning", afternoon: "Afternoon", with: "With", at: "At", in: "At",
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    footer_res: "Activity planning of the Residence", from: "From", to: "to" },
};
const PLACES_NL = { salon: "Salon", "salle d'animation": "Animatieruimte", "salle animation": "Animatieruimte",
  refectoire: "Refter", "salle a manger": "Eetzaal", cafeteria: "Cafetaria", jardin: "Tuin", terrasse: "Terras",
  chapelle: "Kapel", "salle polyvalente": "Polyvalente zaal", bibliotheque: "Bibliotheek", hall: "Hal",
  cuisine: "Keuken", "salle de kine": "Kinesitherapieruimte", "salle snoezelen": "Snoezelruimte", snoezelen: "Snoezelruimte",
  chambre: "Kamer", exterieur: "Buiten", "salle de bain": "Badkamer", "salle de repos": "Rustruimte", cour: "Binnenplaats",
  veranda: "Veranda", "espace detente": "Ontspanningsruimte", "salle de reunion": "Vergaderzaal", "salle tv": "Tv-ruimte",
  "salle de restaurant": "Restaurantzaal", restaurant: "Restaurant", atrium: "Atrium", "1er etage": "1e verdieping",
  "2e etage": "2e verdieping", "3e etage": "3e verdieping", "rez-de-chaussee": "Gelijkvloers", "rez de chaussee": "Gelijkvloers" };
const norm = (s) => (s || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const trPlace = (p, lang) => (lang === "nl" && p ? (PLACES_NL[norm(p)] || p) : p || "");
const FOOTER_NL = { "bonne semaine !": "Fijne week !", "bonne semaine": "Fijne week", "belle semaine !": "Mooie week !" };
const trFooter = (f, lang) => (lang === "nl" && f ? (FOOTER_NL[norm(f)] || f) : f || "");

export function AffichePreview({ meta, acts }) {
  const [prim, light] = THEME_FULL[meta.theme] || THEME_FULL.bleu;
  const L = LABELS[meta.lang] || LABELS.fr;
  const moments = ["morning", "afternoon"];
  let ws = null;
  try { if (meta.week_start) { const [y, m, d] = meta.week_start.split("-").map(Number); ws = new Date(y, m - 1, d); } } catch { /* noop */ }
  const dateOf = (i) => { if (!ws) return null; const d = new Date(ws); d.setDate(d.getDate() + i); return d; };
  let period = meta.period;
  if (!period && ws) { const e = dateOf(6); period = `${L.from} ${L.days[0].toLowerCase()} ${String(ws.getDate()).padStart(2, "0")} ${L.months[ws.getMonth()]} ${L.to} ${L.days[6].toLowerCase()} ${String(e.getDate()).padStart(2, "0")} ${L.months[e.getMonth()]} ${e.getFullYear()}`; }
  const cellActs = (d, mo) => acts.filter((a) => a.day === d && a.moment === mo);

  return (
    <div className="w-full bg-white text-black rounded-lg overflow-hidden shadow-xl border" style={{ aspectRatio: "16/9" }} data-testid="affiche-preview">
      <div className="h-full flex flex-col">
        {/* Bandeau titre */}
        <div className="flex items-center px-3 py-2 relative" style={{ background: prim, height: "13%" }}>
          <div className="text-black font-bold text-[11px] sm:text-sm truncate">{[meta.group, meta.residence].filter(Boolean).join("  —  ")}</div>
          <div className="absolute left-1/2 -translate-x-1/2 text-black font-extrabold text-sm sm:text-lg">{L.title}</div>
          {period && <div className="ml-auto text-black text-[9px] sm:text-[11px] max-w-[30%] text-right truncate">{period}</div>}
        </div>
        {/* Grille */}
        <div className="flex-1 flex px-1.5 pt-1.5 gap-1 min-h-0">
          {/* Colonne moments */}
          <div className="flex flex-col gap-1" style={{ width: "4%" }}>
            <div style={{ height: "18%" }} />
            {moments.map((mo) => (
              <div key={mo} className="flex-1 flex items-center justify-center rounded" style={{ background: prim }}>
                <span className="text-black font-bold text-[8px] sm:text-[10px]" style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}>{mo === "morning" ? L.morning : L.afternoon}</span>
              </div>
            ))}
          </div>
          {/* 7 jours */}
          <div className="flex-1 grid grid-cols-7 gap-1 min-h-0">
            {L.days.map((dname, di) => (
              <div key={di} className="flex flex-col gap-1 min-h-0">
                {/* En-tête jour */}
                <div className="flex flex-col items-center justify-center rounded text-center" style={{ height: "18%", background: light, border: `1px solid ${prim}` }}>
                  <span className="font-bold text-[8px] sm:text-[11px] leading-none" style={{ color: "#000" }}>{dname}</span>
                  {dateOf(di) && <span className="font-bold text-[7px] sm:text-[9px] leading-none mt-0.5" style={{ color: "#000" }}>{String(dateOf(di).getDate()).padStart(2, "0")} {L.months[dateOf(di).getMonth()]}</span>}
                </div>
                {/* Cellules matin/après-midi */}
                {moments.map((mo) => {
                  const list = cellActs(di, mo);
                  const imgMaxH = list.length >= 3 ? "22%" : list.length === 2 ? "28%" : "40%";
                  return (
                  <div key={mo} className="flex-1 rounded p-0.5 overflow-hidden flex flex-col gap-0.5" style={{ background: "#fff", border: `1px solid ${prim}` }}>
                    {list.map((a, i) => (
                      <div key={i} className="text-center leading-tight flex-1 flex flex-col items-center justify-center min-h-0 overflow-hidden">
                        <div className="font-bold text-[7px] sm:text-[10px]" style={{ color: "#000" }}>{meta.lang === "nl" ? (a.name_nl || a.name) : meta.lang === "en" ? (a.name_en || a.name) : a.name}</div>
                        {a.start && <div className="font-semibold text-[6px] sm:text-[8px]" style={{ color: "#000" }}>{L.at} {a.start}{a.end ? ` - ${a.end}` : ""}</div>}
                        {a.place && <div className="text-[6px] sm:text-[8px]" style={{ color: "#000" }}>{L.in} {trPlace(a.place, meta.lang)}</div>}
                        {a.animators && <div className="text-[6px] sm:text-[8px]" style={{ color: "#000" }}>{L.with} {a.animators}</div>}
                        {a.function && <div className="text-[6px] sm:text-[8px] font-medium" style={{ color: "#000" }}>{functionLabel(a.function, meta.lang)}</div>}
                        {a.image_url && <img src={imgSrc(a.image_url)} alt="" className="mt-0.5 rounded object-cover shrink-0" style={{ maxHeight: imgMaxH, maxWidth: "80%" }} />}
                      </div>
                    ))}
                  </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
        {/* Pied */}
        <div className="flex items-center justify-between px-3 py-1" style={{ height: "10%" }}>
          <span className="font-bold text-[7px] sm:text-[9px]" style={{ color: "#000" }}>{period}</span>
          <span className="font-bold text-[8px] sm:text-[11px] text-center flex-1" style={{ color: "#000" }}>{L.footer_res} {meta.residence}</span>
          <span className="font-bold text-[8px] sm:text-[11px]" style={{ color: "#000" }}>{trFooter(meta.footer, meta.lang)}</span>
        </div>
      </div>
    </div>
  );
}
